import { useProductFeatures } from "./useProductFeatures";

// TODO - get rid of this - we should really only be using feature flags and not some derived school level
// Example of how to use:
//   const { matchesSchoolLevel } = useSchoolLevels();
//   if (matchesSchoolLevel("ms")) {
//     console.log("User is in MS");
//   }
export const useSchoolLevels = () => {
  const { matchesProductPlans, isLoading: isLoadingProductFeatures } =
    useProductFeatures();

  const schoolLevels = [];

  if (matchesProductPlans(["ms-staff", "ms-possibilities-ux"])) {
    schoolLevels.push("ms");
  }

  if (
    matchesProductPlans([
      "wbl-staff",
      "wbl-ux",
      "wbl-career-prep-staff",
      "wbl-capstone-staff",
      "wbl-practicum-staff",
    ])
  ) {
    schoolLevels.push("hs");
  }

  // The wf product grants educators `launch-content` (not wf-staff/wf-ux), so
  // without it here a coach who also holds an MS product matched only "ms"
  // above, never reached the empty fallback, and lost the "wf" level.
  // `launch-content` is also on the syep/agvep products; those are workforce
  // programs, and their educators already landed on "wf" via the empty
  // fallback, so matching it here doesn't widen who gets the level.
  if (
    matchesProductPlans(["wf-staff", "wf-ux", "launch-content"]) ||
    schoolLevels.length === 0
  ) {
    schoolLevels.push("wf");
  }

  return {
    isLoadingSchoolLevels: isLoadingProductFeatures,
    schoolLevels,
    matchesSchoolLevel: (level) => schoolLevels.includes(level),
    matchesSchoolLevels: (levels) =>
      levels.some((level) => schoolLevels.includes(level)),
  };
};
